/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./ContentPlaceholder.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-contentPlaceholder");
var getStyleByRatio = function (ratio) {
    return ratio === "auto"
        ? undefined
        : {
            paddingTop: ratio * 100 + "%",
            height: 0
        };
};
var wrapChildren = function (children) { return (React.createElement("div", { className: moduleClassName("content") },
    React.createElement("div", null, children))); };
exports.ContentPlaceholder = function ContentPlaceholder(_a) {
    var ratio = _a.ratio, children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames(moduleClassName(), className), style: getStyleByRatio(ratio) }, ratio === "auto" ? (wrapChildren(children)) : (React.createElement("div", { className: moduleClassName("contentWrapper") }, wrapChildren(children)))));
};
exports.ContentPlaceholder.propTypes = {
    ratio: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number])
        .isRequired
};